module.exports = __webpack_public_path__ + "img/WG.1a573663.svg";